import { render } from "./CorrectTwoView.vue?vue&type=template&id=bde51a76&ts=true"
import script from "./CorrectTwoView.vue?vue&type=script&lang=ts"
export * from "./CorrectTwoView.vue?vue&type=script&lang=ts"

import "./CorrectTwoView.vue?vue&type=style&index=0&id=bde51a76&lang=scss"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__